import { SectorsList } from "../../shared/sectors/SectorsList";

interface SectorsSectionProps {
 title: string;
 subtitle : string;
 sectors: any
}
export default function SectorsSection({title , sectors , subtitle }: SectorsSectionProps) {
  

    return (
        <section className="py-8 md:py-12 px-4 md:px-8 max-w-7xl mx-auto">
            <div className="mb-6 md:mb-8">
                <h2 className="text-sm md:text-base font-semibold text-gray-900 uppercase tracking-wide">
                  {title || "Secteurs d'activtés"}
                </h2>
                <p className="text-xs md:text-sm text-gray-500 mt-1">
                  {subtitle || "   Choisissez un secteur pour explorer les catégories"}
                </p>
            </div>

            <SectorsList sectors={sectors}  />
        </section>
    )
}
